exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dasbboardEmployeeRevenueChart-664a2{width:35%}", ""]);

// Exports
exports.locals = {
	"dasbboardEmployeeRevenueChart": "dasbboardEmployeeRevenueChart-664a2"
};